import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import moment from "moment";

import { selectService } from "services";
import {
  Modal,
  Checkbox,
  DatePicker,
  Dropdown,
  Input,
  Button,
  Select,
  Divider,
  Icon,
  Menu,
} from "antd";
import { dateFormat, datePickerProps, selectProps } from "utils";
import { mail } from "assets/static/invitation.html.js";

const InvitationsTable = (props) => {
  const { invitations = [], submission } = props;
  const [updated, setUpdated] = useState(false);
  const [changes, setChanges] = useState({});

  const updateInvitation = (id, value, key) => {
    const index = invitations.findIndex((i) => i.id === id);
    setUpdated(true);
    setChanges({
      ...changes,
      [index]: { ...changes[index], [key]: value },
    });
  };

  const submitUpdates = () => {
    const updateInvitations = [...invitations];
    for (let index in changes) {
      for (let key in changes[index]) updateInvitations[index][key] = changes[index][key];
    }

    props.onUpdate(updateInvitations, setUpdated(false));
  };

  const renderLine = (invitation = null, isTitle = false) => {
    if (!invitation?.id && !isTitle) return <></>;
    return (
      <div key={invitation?.id || 0}>
        {COLS.map((col, i) => (
          <div key={i}>
            {isTitle
              ? col.title
              : col.render(invitation, (val, key) => updateInvitation(invitation.id, val, key))}
          </div>
        ))}
      </div>
    );
  };

  let mailto = "mailto:info@clbinc.com";
  mailto += `?subject=${encodeURIComponent(
    "Invitation à soumissionner" + (submission.num ? `[${submission.num}]` : ""),
  )}`;
  mailto += `&body=${encodeURIComponent(mail(submission))}`;
  let invitees = invitations
    .filter((i) => !!(i.supplier && i.supplier.mail))
    .map((i) => i.supplier.mail);

  if (invitations.length === 0) return <b>Aucune invitation pour le moment...</b>;

  return (
    <div>
      <div className="invitations-table">
        {renderLine(null, true)}
        {invitations.map((i) => renderLine(i))}
      </div>

      <div className="buttons">
        {updated && (
          <Button type="primary" onClick={submitUpdates}>
            <Icon type="save" />
            Sauvegarder les modifications
          </Button>
        )}
        <Dropdown
          type="primary"
          placement="topCenter"
          overlay={
            <Menu>
              <Menu.Item key="outlook" className="email-send-dropdown-item">
                <a target="_blank" href={mailto + `&bcc=${invitees.join(";")}`}>
                  Client Outlook
                </a>
              </Menu.Item>
              <Menu.Item key="others" className="email-send-dropdown-item">
                <a target="_blank" href={mailto + `&bcc=${invitees.join(",")}`}>
                  Autres Clients
                </a>
              </Menu.Item>
            </Menu>
          }
        >
          <Button type="primary">
            <Icon type="mail" />
            Envoyer un courriel
          </Button>
        </Dropdown>
      </div>
    </div>
  );
};

const NewModal = (props) => {
  const [supplierIds, setSupplierIds] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [filters, setFilters] = useState({});

  useEffect(() => {
    fetchSuppliers();
    return () => {
      setSupplierIds([]);
      setSuppliers([]);
      setFilters({});
    };
  }, []);

  const suppliersAlreadyInvitedIds = (props.submission.invitations || []).map((i) => i.supplier_id);

  const fetchSuppliers = async () => {
    for (let key in filters) {
      if (!filters[key]) delete filters[key];
    }

    filters.exclude = suppliersAlreadyInvitedIds;
    const suppliers = await selectService.listSuppliers(filters);
    setSupplierIds([]);
    setSuppliers(suppliers);
  };

  const updateFilters = (obj) => {
    const toUpdate = { ...filters, ...obj };
    setFilters(toUpdate);
  };

  const submitCreation = () => {
    props.onCreate(supplierIds.map((id) => ({ supplier_id: id })));
  };

  const regions = props.selects?.Region || [];
  const specialityTypes = props.selects?.SpecialityType || [];
  const specialities = (props.selects?.Speciality || []).filter((s) => {
    if (!filters.speciality_type_id) return true;
    return s.speciality_type_id === filters.speciality_type_id;
  });

  return (
    <>
      <div className="new-invitation-filters">
        <div className="ctn">
          <label>Favori</label>
          <Checkbox
            checked={!!filters.fav}
            onChange={(e) => updateFilters({ fav: e.target.checked ? 1 : 0 })}
          />
        </div>
        <div className="ctn">
          <label>Région :</label>
          <Select
            size="small"
            value={filters.region_id}
            onChange={(val) => updateFilters({ region_id: val })}
            {...selectProps()}
          >
            {regions.map((t) => (
              <Select.Option key={t.id} value={t.id}>
                {t.label}
              </Select.Option>
            ))}
          </Select>
        </div>
        <div className="ctn">
          <label>Ville :</label>
          <span>
            <Input
              size="small"
              value={filters.city || ""}
              onChange={(e) => updateFilters({ city: e.target.value })}
            />
          </span>
        </div>
        <div className="ctn">
          <label>Spécialité :</label>
          <Select
            size="small"
            value={filters.speciality_type_id}
            onChange={(val) => updateFilters({ speciality_type_id: val, speciality_id: null })}
            {...selectProps()}
          >
            {specialityTypes.map((t) => (
              <Select.Option key={t.id} value={t.id}>
                {t.label}
              </Select.Option>
            ))}
          </Select>
        </div>
        <div className="ctn">
          <label>Sous-spécialité :</label>
          <Select
            size="small"
            value={filters.speciality_id}
            onChange={(val) => updateFilters({ speciality_id: val })}
            {...selectProps()}
          >
            {specialities.map((s) => (
              <Select.Option key={s.id} value={s.id}>
                {s.label}
              </Select.Option>
            ))}
          </Select>
        </div>
      </div>

      <Divider />

      <div className="ctn">
        <label>
          <b>Fournisseur :</b>
        </label>
        <Select
          mode="multiple"
          value={supplierIds}
          onChange={(ids) => setSupplierIds(ids)}
          {...selectProps()}
        >
          {suppliers
            .filter((s, i) => suppliers.findIndex((t) => s.id === t.id) === i)
            .map((supplier) => (
              <Select.Option key={supplier.id} value={supplier.id}>
                {supplier.name}
              </Select.Option>
            ))}
        </Select>
      </div>

      <div className="buttons">
        <Button type="link" onClick={props.closeModal}>
          Annuler
        </Button>
        <Button type="primary" disabled={supplierIds.length === 0} onClick={submitCreation}>
          Créer l'invitation
        </Button>
      </div>
    </>
  );
};

const COLS = [
  {
    title: "Nom des fournisseurs",
    render: (i) => <b>{i.supplier?.name}</b>,
  },
  {
    title: "Accepte",
    render: (i, callback) => (
      <Checkbox
        defaultChecked={i.accepted}
        onChange={(e) => callback(e.target.checked, "accepted")}
      />
    ),
  },
  {
    title: "Appel",
    render: (i, callback) => (
      <Checkbox defaultChecked={i.called} onChange={(e) => callback(e.target.checked, "called")} />
    ),
  },
  {
    title: "Mail",
    render: (i, callback) => (
      <Checkbox
        defaultChecked={i.emailed}
        onChange={(e) => callback(e.target.checked, "emailed")}
      />
    ),
  },
  {
    title: "Date inv.",
    render: (i, callback) => (
      <DatePicker
        showTime
        {...datePickerProps(true)}
        defaultValue={i.date_created ? moment(i.date_created) : null}
        onChange={(val) => callback(val, "date_created")}
      />
    ),
  },
  {
    title: "Date maj",
    render: (i, callback) => (
      <DatePicker
        showTime
        {...datePickerProps(true)}
        defaultValue={i.date_updated ? moment(i.date_updated) : null}
        onChange={(val) => callback(val, "date_updated")}
      />
    ),
  },
  {
    title: "Notes",
    render: (i, callback) => (
      <Input defaultValue={i.note} onChange={(e) => callback(e.target.value, "note")} />
    ),
  },
  {
    title: "Courriel",
    render: (i) => <i>{i.supplier?.mail}</i>,
  },
  {
    title: "Tel",
    render: (i) => <i>{i.supplier?.tel}</i>,
  },
];

InvitationsTable.NewModal = NewModal;
export default InvitationsTable;
